export default __webpack_public_path__ + "static/media/icon-collaboration.6c80c0a4.svg";